import InvoiceListCard from "@legacy/invoices/components/InvoiceListCard"

import useHasAccess from "@hooks/useHasAccess"
import useSlugExtractor from "@hooks/useSlugExtractor"

import { CardList, Table, ViewBar, ViewMenu } from "@organisms"
import CardsView from "@organisms/ObjectsView/CardsView/CardsView"

import { EstimateTableViewTabs } from "@pages/Estimates/EstimateList/views/EstimateTableView/EstimateTableViewTabs"

import { ESTIMATES_ROUTES } from "@routes/estimates"

import { PERMISSION_LEVEL } from "@constants/permissionLevel"
import {
    ESTIMATES_LIST_CONTROLS_ACTIVE_TAB,
    ESTIMATES_LIST_CONTROLS_KEYWORD_SEARCH,
    ESTIMATES_LIST_CONTROLS_PHASE,
} from "@constants/storage"

const ESTIMATE_CARDS_VIEW_ATTRIBUTES = [
    { value: "client_name", label: "Client" },
    { value: "service_name", label: "Service" },
    { value: "service_location_name", label: "Location Name" },
    { value: "service_location_address", label: "Location Address" },
    { value: "labels", label: "Labels" },
    { value: "total", label: "Total" },
    { value: "date_due", label: "Expires" },
    { value: "date_issued", label: "Issued" },
]

const ESTIMATE_CARDS_VIEW_SORT_OPTIONS = [
    { value: "id", label: "ID" },
    { value: "client_name", label: "Client" },
    { value: "status_label", label: "Status" },
    { value: "total", label: "Total" },
    { value: "service_name", label: "Service" },
    { value: "service_location_name", label: "Location Name" },
    { value: "service_location_address", label: "Location Address" },
    { value: "date_issued", label: "Issued" },
    { value: "date_due", label: "Expires" },
    { value: "down_payment_status", label: "Down Payment" },
    { value: "last_modified_at", label: "Last Modified" },
    { value: "last_viewed", label: "Seen" },
    { value: "last_sent_at", label: "Sent" },
    { value: "last_approved_at", label: "Approved" },
    { value: "last_won_at", label: "Won" },
    { value: "last_lost_at", label: "Lost" },
    { value: "last_cancelled_at", label: "Cancelled" },
]

export default function EstimateCardsView() {
    const [createRoute] = useSlugExtractor([ESTIMATES_ROUTES.CREATE])
    const { hasPermission } = useHasAccess()

    return (
        <Table.Provider
            activePhaseStorageKey={ESTIMATES_LIST_CONTROLS_PHASE}
            activeTabStorageKey={ESTIMATES_LIST_CONTROLS_ACTIVE_TAB}
            searchKeywordsStorageKey={ESTIMATES_LIST_CONTROLS_KEYWORD_SEARCH}
            listTitle="Estimates"
            objectType="estimate"
            objectIndexName="Estimate"
            objectName="Estimate"
            defaultActivePhase="open"
            objectCreateRoute={createRoute}
            isRowClickable={hasPermission("estimates_view_permission", PERMISSION_LEVEL.FULL)}
            isEmptyStateCreateButtonVisible={hasPermission("estimates_create_permission", PERMISSION_LEVEL.RESTRICTED)}
        >
            <CardsView.Provider
                attributes={ESTIMATE_CARDS_VIEW_ATTRIBUTES}
                sortOptions={ESTIMATE_CARDS_VIEW_SORT_OPTIONS}
            >
                <ViewBar.Root>
                    <ViewBar.Start>
                        <ViewBar.Phases>
                            <Table.Phase phase="open" title="Open" />
                            <Table.Phase phase="closed" title="Closed" />
                        </ViewBar.Phases>
                        <ViewBar.VerticalDivider />
                        <EstimateTableViewTabs />
                    </ViewBar.Start>
                    <ViewBar.End>
                        <Table.SearchInput />
                        <ViewMenu />
                    </ViewBar.End>
                </ViewBar.Root>
                <CardList CardComponent={InvoiceListCard} />
            </CardsView.Provider>
        </Table.Provider>
    )
}
